import { createSlice } from '@reduxjs/toolkit';
import { 
  addNotificationReducer, 
  checkPendingNotificationReducer, 
  confirmNotificationDeliveredReducer, 
  confirmNotificationReadReducer, 
  deleteAllNotificationsReducer, 
  deleteNotificationReducer, 
  getPendingNotificationsReducer, 
  markAsDeliveredReducer, 
  markAsReadReducer, 
  addNotificationsReducer, 
  updateNotificationReducer,
} from './reducers';
import { NotificationSliceState, NotificationState } from './types';
import api from '../services/api';

const initialState: NotificationSliceState = {
  pendingNotifications: [],
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    addNotification: addNotificationReducer,
    addNotifications: addNotificationsReducer,
    deleteNotification: deleteNotificationReducer,
    checkPendingNotification: checkPendingNotificationReducer,
    deleteAllNotifications: deleteAllNotificationsReducer,
    updateNotification: updateNotificationReducer,
    markAsRead: markAsReadReducer,
    markAsDelivered: markAsDeliveredReducer,
    confirmNotificationRead: confirmNotificationReadReducer,
    confirmNotificationDelivered: confirmNotificationDeliveredReducer,
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.getPendingNotifications.matchFulfilled, getPendingNotificationsReducer);
    builder.addMatcher(api.endpoints.readNotification.matchFulfilled, confirmNotificationReadReducer);
    builder.addMatcher(api.endpoints.deliverNotification.matchFulfilled, confirmNotificationDeliveredReducer);
  },
});

const getNotifications = (state: NotificationSliceState): NotificationState[] => {
  return (state && state.pendingNotifications) ?? [];
};

const getUnreadCount = (state: NotificationSliceState): number => {
  return (state && state.unreadCount) ?? 0;
};

const getNotificationById = (state: NotificationSliceState, id: string): NotificationState | null => {
  return (state && state.pendingNotifications.find((notification) => notification.id === id)) ?? null;
}

export default notificationSlice;

export const actions = notificationSlice.actions;
export const selectors = {
  getNotifications,
  getUnreadCount,
  getNotificationById,
};
